const Labels = ({ data, title }) => {
    return (<div
        className="labels-container"
    >
        {title && <h4>{title}</h4>}
        {Object.entries(data).map(([title, value]) => {
            return <div
                key={title}
            >
                <div style={{fontWeight: "bold"}}>{title.toUpperCase()}:</div>
                <div style={{justifyContent: "right"}}>{value}</div>
            </div>
        })}
    </div>   
)}

export default Labels;